import { useCallback } from 'react';
import classNames from 'classnames';

import MEMBERSHIP_OFFERED_ITEMS from '../../../../../utils/membership';
import { QUANTITY_TYPES } from '../../../../../config/config';
import { useSubscription } from '../../../SubscriptionProvider';
import { getIntervalTag } from '../../../../../utils/subscriptions';
import { RECYCLING_PRODUCT_TYPES } from '../../../../../utils/tbbRegistration';

import './SubscriptionSelectionSummary.scss';

const SubscriptionSelectionSummary = ({
  selectedItems = {},
}) => {
  const {
    subscriptionPlan,
    productPrices,
    subtotal,
  } = useSubscription();

  const {
    value: subscriptionValue,
    prevValue: subscriptionPrevValue,
    interval: subscriptionInterval,
  } = subscriptionPlan;

  const getSummaryItem = useCallback((itemId) => {
    const item = MEMBERSHIP_OFFERED_ITEMS[itemId];
    const count = selectedItems[itemId] || 0;
    const labelKey = count === 1 ? QUANTITY_TYPES.SINGULAR : QUANTITY_TYPES.PLURAL;
    const value = (
      itemId === RECYCLING_PRODUCT_TYPES.VIRTUAL ?
        productPrices.TECH_BOX : productPrices[itemId] ?? 0
    ) * count;

    return {
      count,
      label: item.quantityLabel[labelKey],
      value,
    };
  }, [selectedItems, productPrices]);

  const savings = Math.max(subtotal - subscriptionValue, 0);

  return (
    <div className="SubscriptionSelectionSummary">
      {Object.keys(selectedItems).map(itemId => {
        const { count, label, value } = getSummaryItem(itemId);

        return (
          <SubscriptionSelectionSummaryItem
            key={`SubscriptionSelectionSummaryItem-${itemId}`}
            itemId={itemId}
            count={count}
            label={label}
            value={value}
          />
        );
      })}
      <div className="SubscriptionSelectionSummary__subtotal">
        <span>Subtotal</span>
        <span>{`$${subtotal}`}</span>
      </div>
      <div className={classNames('SubscriptionSelectionSummary__savings', { positive: savings > 0 })}>
        <span>Savings today</span>
        <span className="value">{`$${savings}`}</span>
      </div>
      <div className="SubscriptionSelectionSummary__subscription">
        <span>Trashie Unlimited</span>
        <span className="price">
          {!!subscriptionPrevValue && (
            <span className="prev-value">{`$${subscriptionPrevValue}`}</span>
          )}
          {`$${subscriptionValue}`}
          {getIntervalTag(subscriptionInterval)}
        </span>
        <span className="description">
          Unlimited free reorders all year
        </span>
      </div>
    </div>
  );
};

const SubscriptionSelectionSummaryItem = ({
  itemId = '',
  count = 0,
  label = '',
  value = 0,
}) => (
  <>
    <div className="SubscriptionSelectionSummary__item" key={itemId}>
      <span>{`${count} x ${label}`}</span>
      <span>{`$${value}`}</span>
    </div>
    <div className="SubscriptionSelectionSummary__divider" />
  </>
);

export default SubscriptionSelectionSummary;
